import { RadioTypes } from "../commonTypes/universalTypes";

export const SCHEDULING_USER_VIEW_OPTIONS: RadioTypes[] = [
    {
        id: "future_jobs",
        name: "Future Jobs",
    },
    {
        id: "open_jobs",
        name: "Current Open Jobs",
    },
];
export const SCHEDULING_ESTIMATE_JOB_OPTIONS: RadioTypes[] = [
    {
        id: "oneTime",
        name: "One Time",
    },
    {
        id: "daily",
        name: "Daily",
    },
];